import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-common-types";

import { FontAwesomeIcon } from "@performyard/fontawesome/react-fontawesome";

type SuggestedAction = {
	label: string;
	icon?: IconDefinition;
	onClick: () => void;
	disabled?: boolean;
};

type SuggestedActionsProps = {
	actions: SuggestedAction[];
	/** Text button size. "small" (default) = caption/9px icon; "large" = paragraph-3 (14px)/11px icon. */
	size?: "small" | "large";
};

export const SuggestedActions: React.FC<SuggestedActionsProps> = ({ actions, size = "small" }) => {
	if (actions.length === 0) return null;
	const textSizeClass = size === "large" ? "text-paragraph-3" : "text-caption";
	const iconFontSize = size === "large" ? "11px" : "9px";
	return (
		<div className="flex flex-col items-start gap-1">
			{actions.map((action) => (
				<button
					key={action.label}
					type="button"
					onClick={action.onClick}
					disabled={action.disabled}
					className={`${textSizeClass} inline-flex items-center gap-1 border-none bg-transparent p-0 font-semibold ${
						action.disabled
							? "cursor-not-allowed text-neutral-5"
							: "text-primary-5 hover:cursor-pointer hover:text-primary-7 hover:underline active:text-primary-8 active:underline"
					}`}
				>
					{action.icon && <FontAwesomeIcon icon={action.icon} style={{ fontSize: iconFontSize }} />}
					<span className="whitespace-nowrap">{action.label}</span>
				</button>
			))}
		</div>
	);
};
